export const DOCUMENT_REQUEST_TYPES = {
  employment_verification: {
    label: 'Employment Verification',
    documentTypeName: 'Employment Verification',
    description: 'Confirm your employment, position, and current company details.',
    purposeMode: 'select',
  },
  pr_support: {
    label: 'PR Application Support',
    documentTypeName: 'PR Application Support',
    description: 'Support a permanent-residency or immigration application.',
    purposeMode: 'fixed',
    purpose: 'pr_immigration',
  },
  home_leave: {
    label: 'Home Leave Authorization',
    documentTypeName: 'Home Leave Authorization',
    description: 'Notify immigration about approved home-leave travel.',
    purposeMode: 'fixed',
    purpose: 'home_leave_immigration',
  },
};

export const DOCUMENT_REQUEST_TYPE_OPTIONS = Object.entries(
  DOCUMENT_REQUEST_TYPES,
).map(([value, config]) => ({
  value,
  label: config.label,
}));

export const DOCUMENT_REQUEST_PURPOSE_OPTIONS = [
  { value: 'visa_application', label: 'Visa Application' },
  { value: 'pr_immigration', label: 'PR / Immigration' },
  { value: 'work_pass', label: 'Work Pass / Renewal' },
  { value: 'bank_loan', label: 'Bank Loan' },
  { value: 'bank_account', label: 'Opening a Bank Account' },
  { value: 'tenancy', label: 'Tenancy Agreement' },
  { value: 'background_check', label: 'Background Check' },
  { value: 'education', label: 'Education Enrolment' },
  { value: 'travel', label: 'Travel' },
  { value: 'other', label: 'Other' },
];

export const getDocumentRequestType = (requestType) =>
  DOCUMENT_REQUEST_TYPES[requestType] || {
    label: requestType
      ? requestType.replace(/_/g, ' ')
      : 'Official HR Letter',
    documentTypeName: '',
    description: '',
    purposeMode: 'select',
  };

export const getDocumentRequestPurposeLabel = (request) => {
  if (request?.purpose_display) return request.purpose_display;
  if (request?.purpose === 'other') return request.purpose_other || 'Other';
  const option = DOCUMENT_REQUEST_PURPOSE_OPTIONS.find(
    (item) => item.value === request?.purpose,
  );
  return option?.label || request?.purpose || 'Not specified';
};
